import {
  Button,
  Tab,
  TabContext,
  TabList,
  TabPanel,
} from '@global-engineering-shared/gweb-material-ui';
import React, { useEffect, useState } from 'react';

import { filterFrameIds, filterValues } from 'components/FilterAutocomplete/utils/filterValues';
import { useFilters } from 'context/FilterProvider/FilterProvider';
import { Filters } from 'context/FilterProvider/types/Filters';
import { defaultFilters } from 'context/FilterProvider/utils/defaultFilters';
import useStyles from 'features/Frames/components/Frames/FramesFilters/FramesFilters.styles';
import FramesFiltersList from 'features/Frames/components/Frames/FramesFilters/FramesFiltersList/FramesFiltersList';
import useFetchWithToken from 'hooks/useFetchWithToken';
import { FILTERS_API_URL, FRAMES_API_URL } from 'utils/environmentVariables';

const emptyFilters = {} as Filters;

type FramesFiltersProps = {
  setDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const FramesFilters = ({ setDrawerOpen }: FramesFiltersProps) => {
  const FRAME_IDS_API_URL = FRAMES_API_URL + '/ids';

  const classes = useStyles();
  const [filterData, setFilterData] = useState<Filters>(defaultFilters);
  const [frameIds, setFrameIds] = useState<string[]>([]);
  const [selectedFilters, setSelectedFilters] = useState<Filters>({} as Filters);
  const [selectedTab, setSelectedTab] = useState<string>('1');
  const [filterResponse, setFilterOptions] = useState<Filters>(defaultFilters);
  const { setFilters } = useFilters();
  const { fetchDataWithToken } = useFetchWithToken();

  const submitFilters = () => {
    setFilters(selectedFilters);
    setDrawerOpen(false);
  };

  const changeTab = (event: any, newValue: string) => {
    setSelectedFilters(emptyFilters);
    setSelectedTab(newValue);
  };

  useEffect(() => {
    fetchDataWithToken<Filters>(FILTERS_API_URL, (data) => setFilterData(data));
    fetchDataWithToken<string[]>(FRAME_IDS_API_URL, (res) => setFrameIds(res));
  }, []);

  useEffect(() => {
    const loadData = async () => {
      if (!filterData && !frameIds) return;
      setFilterOptions((prev) => ({
        ...prev,
        ...filterData,
        frameId: frameIds,
      }));
    };
    loadData();
  }, [filterData, frameIds]);

  return (
    <div className={classes.filterComponent}>
      <TabContext value={selectedTab}>
        <div className={classes.tabList}>
          <TabList onChange={changeTab}>
            <Tab className={classes.tab} label="Multiple Filters" value="1" />
            <Tab label="Frame IDs only" value="2" />
          </TabList>
        </div>
        <TabPanel value="1" className={classes.tabPanel}>
          <FramesFiltersList
            filterValues={filterValues}
            setSelectedFilters={setSelectedFilters}
            filterResponse={filterResponse}
          />
        </TabPanel>
        <TabPanel value="2" className={classes.tabPanel}>
          <FramesFiltersList
            filterValues={filterFrameIds}
            setSelectedFilters={setSelectedFilters}
            filterResponse={filterResponse}
          />
        </TabPanel>
      </TabContext>
      <Button onClick={submitFilters} className={classes.applyButton}>
        Apply
      </Button>
    </div>
  );
};

export default FramesFilters;
